import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {parseProposedChangeCardProps} from './proposed-change-card.library';
import {ProposedChangeCard} from './proposed-change-card';

export const proposedChangeCardRegistration = defineStreamComponentRegistration(StreamComponentType.PROPOSED_CHANGE_CARD, ProposedChangeCard, parseProposedChangeCardProps);
